import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-search-admin',
  templateUrl: './search-admin.component.html',
  styleUrl: './search-admin.component.scss'
})
export class SearchAdminComponent {

  searchQuery = '';
  @Output() SQuery = new EventEmitter<string>();
  onEnter(){
    this.SQuery.emit(this.searchQuery);
  }

}
